import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FuncionService } from '../../servicios/funcion.service';
import { environment } from '../../../environments/environment.prod';

import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import * as $ from 'jquery';

@Component({
	selector: 'app-recuperacion',
	templateUrl: './recuperacion.component.html',
	styleUrls: ['./recuperacion.component.css'],
	animations: [
    	trigger('tgTelefono',[
        	state('inicial',style({
            	marginBottom:'30px'
        	}))
        ])
    ]
})
export class RecuperacionComponent implements OnInit {

	estiloTelefono = "inicial";

	esEmail:boolean = true;
	correo:string = "";
	telefono:string = "";
	newMensaje:string = "";

	constructor(
		private newFuncionService:FuncionService,
		private newRouter:Router,
		private newTitle: Title,
		@Inject(PLATFORM_ID) private platformId: Object
		){ }

	ngOnInit() {
		this.newTitle.setTitle("Recuperación de contraseña");
	}

	fnCambiarOpcion( newOpcion ){
		this.esEmail = newOpcion;
		if( !this.esEmail ){
			if (isPlatformBrowser(this.platformId)){
				setTimeout(()=>{
					$(".iti__flag-container").css({left:"20px"});
				});
			}
		}
	}

	telInputObject(obj) {
		obj.setCountry('mx');
	}

	hasError( newEvent ){
		if( !newEvent ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.telefono.formato );
		}
	}

	getNumber( newEvent ){
		this.telefono = newEvent;
	}

	onCountryChange( newEvent ){ }

	fnEnviarPeticion(){
		var newRequest
		if( this.esEmail ){
			newRequest = { tipo:1, correo:this.correo };
			this.newFuncionService.setNewMensaje( "Enviando tu solicitud de recuperación vía correo electrónico." );
		}else{
			newRequest = { tipo:2, telefono:this.telefono };
			this.newFuncionService.setNewMensaje( "Enviando tu solicitud de recuperación vía SMS." );
		}
		this.newFuncionService.fnSolicitudRecuperacion( { solicitud:newRequest } )
		.subscribe( (response:any) => {
			this.newFuncionService.setNewMensaje( null );
			if(response.success){
				if( this.esEmail ){
					this.newFuncionService.setNewAlerta(environment.alerta.recuperacion.correo.success);
				}else{
					this.newFuncionService.setNewAlerta(environment.alerta.recuperacion.telefono.success);
				}
				this.newRouter.navigate([ 'acceso' ]);
			}else{
				if(response.code === 0 ){
					if( this.esEmail ){
						this.newFuncionService.setNewAlerta( environment.alerta.recuperacion.correo.notFound );
					}else{
						this.newFuncionService.setNewAlerta( environment.alerta.recuperacion.telefono.notFound );
					}
				}else{
					this.newFuncionService.setNewAlerta( environment.alerta.recuperacion.fail );
				}
			}
		})
	}


	fnEnviarSolicitud(){
		if( this.esEmail ){
			if( this.correo === "" ){
				this.newFuncionService.setNewAlerta( environment.alerta.recuperacion.correo.vacio );
			}else if( !environment.validacion.correo.test( this.correo ) ){
				this.newFuncionService.setNewAlerta( environment.alerta.recuperacion.correo.formato );
			}else{
				this.fnEnviarPeticion();
			}
		}else{
			if( this.telefono === "" ){
				this.newFuncionService.setNewAlerta( environment.alerta.recuperacion.telefono.vacio );
			}else{
				this.fnEnviarPeticion();
			}
		}
	};

}
